import { ViewModel,View, ObservableArray } from "binder"
import { V4MAPPED } from "dns";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { ProductSearchableSelectorViewModel } from "../productSearch/productSearchableSelector/productSearchableSelector-viewModel";
import  { NoSaleLockAmountManipulationView } from "./noSaleLockAmountManipulation-view"

export class NoSaleLockAmountManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'تنظیم موجودی احتیاط';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.items = ObservableArray.create<singleWarehouseProduct>();
        this.searchProduct = new ProductSearchableSelectorViewModel(this,true);
        this.searchProduct.onSelectionChanged = p=>{
            this.productName = p.productName;
            this.productCode = p.code;
            this.productCarModel = p.productCarModel;
            this.load(p.id);
        }
    }
    GetDefaultView(): View <ViewModel> {
        return new NoSaleLockAmountManipulationView();
    }
    public getTypeId(): string {
        return "VM-13EB6B48-700A-4EE8-890E-563399F4E1C9"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set searchProduct(v: ProductSearchableSelectorViewModel) { this._searchProduct = v; } public get searchProduct(): ProductSearchableSelectorViewModel { return this._searchProduct;} private _searchProduct: ProductSearchableSelectorViewModel;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode;} private _productCode: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set items(v: ObservableArray<singleWarehouseProduct>) { this._items = v; } public get items(): ObservableArray<singleWarehouseProduct> { return this._items;} private _items: ObservableArray<singleWarehouseProduct>;
    private _lastProductId:string;

    async refresh() {
        if(stringIsNullOrEmpty(this._lastProductId))
            return;
        this.load(this._lastProductId);
    }
    async load(productId:string){
        this._lastProductId = productId;
        this.items.clear();
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetNoSaleLockAmountsForProduct',{
                ProductId : productId
            });
            this.items.update(...result.Amounts.map(x=>{
                let r = new singleWarehouseProduct(this);
                r.measuredProductId = result.MeasuredProductId;
                r.warehouseId = x.WarehouseId;
                r.warehouseName = x.WarehouseName;
                r.currentAmount = x.Amount;
                r.newAmount = x.Amount;
                r.balance = x.Balance;
                r.accessibleBalance = x.AccessibleBalance;
                r.isChanged = false;
                return r;
            }));
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}

export class singleWarehouseProduct extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set measuredProductId(v: string) { this._measuredProductId = v; } public get measuredProductId(): string { return this._measuredProductId;} private _measuredProductId: string;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set balance(v: number) { this._balance = v; } public get balance(): number { return this._balance;} private _balance: number;
    public set accessibleBalance(v: number) { this._accessibleBalance = v; } public get accessibleBalance(): number { return this._accessibleBalance;} private _accessibleBalance: number;
    public set currentAmount(v: number) { this._currentAmount = v; } public get currentAmount(): number { return this._currentAmount;} private _currentAmount: number;
    public set newAmount(v: number) { 
        this._newAmount = getAsNumber(v,true); 
        this.isChanged = true;
    } public get newAmount(): number { return this._newAmount;} private _newAmount: number;
    public set isChanged(v: boolean) { this._isChanged = v; } public get isChanged(): boolean { return this._isChanged;} private _isChanged: boolean;
    
    reset(){
        this.newAmount = this.currentAmount;
        this.isChanged = false;
    }
    async update(){
        try {
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/UpdateNoSaleLockAmount',{
                MeasuredProductId : this.measuredProductId,
                WarehouseId : this.warehouseId,
                NewAmount : this.newAmount
            });
            if(result.IsSuccessful){
                this.currentAmount = result.NewAmount;
                this.newAmount = result.NewAmount;
                this.balance = result.Balance;
                this.accessibleBalance = result.AccessibleBalance;
                this.isChanged = false;
                this.messageBoxConfirmSuccess("عملیات با موفقیت انجام شد.","عملیات موفق");
            }else{
                this.messageBoxConfirmWarning("خطا در تنظیم مقدار احتیاط","خطا در عملیات");
            }
        } catch (ex) {
            console.log(ex);
            this.messageBoxConfirmWarning("خطا در تنظیم مقدار احتیاط","خطا در عملیات");
        } finally {
        }
    }
}